import { jsx } from "react/jsx-runtime";
import { ErrorList } from "@contember/ui";
import { useAccessorErrors } from "./useAccessorErrors.js";
function AccessorErrors({ accessor, ...errorListProps }) {
  return /* @__PURE__ */ jsx(ErrorList, { ...errorListProps, errors: useAccessorErrors(accessor) });
}
export {
  AccessorErrors
};
//# sourceMappingURL=AccessorErrors.js.map
